export default "__VITE_ASSET__30adc8b2__"